/**
 * Fallback renderer for plain text / markdown AI responses.
 * Used when type is "message" or when no structured type is present.
 */
import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeHighlight from "rehype-highlight";
import "highlight.js/styles/github.css";

import styles from "./ChatWorkspace.module.scss";

export default function AIResponseMessage({ content = "" }) {
  if (!content) return null;
  return (
    <div className={styles.markdown}>
      <ReactMarkdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeHighlight]}>
        {typeof content === "string" ? content : String(content)}
      </ReactMarkdown>
    </div>
  );
}
